<section id="company-profile" class="company-profile-section">
  <h2 class="section-title">{{ 'SECTIONS.COMPANY_PROFILE' | translate }}</h2>
  <div class="profile-card">
    <div class="filter-group">
      <h4>{{ 'COMPANY_PROFILE.INDUSTRY_QUESTION' | translate }}</h4>
      <div class="industry-cards">
        @for (industry of industries; track industry.id) {
          <button
            type="button"
            class="industry-card"
            [class.active]="isIndustrySelected(industry.id)"
            (click)="toggleIndustry(industry.id)">
            <img [src]="getIndustryImagePath(industry.id)" [alt]="industry.name" class="industry-image" />
            <h5>{{ industry.name }}</h5>
            <p>{{ industry.description }}</p>
          </button>
        }
      </div>
    </div>

    <div class="filter-group">
      <h4>{{ 'COMPANY_PROFILE.DISCIPLINES_QUESTION' | translate }}</h4>
      <div class="filter-buttons">
        @for (discipline of disciplines; track discipline.id) {
          <button
            class="filter-btn"
            [class.active]="isDisciplineSelected(discipline.id)"
            (click)="toggleDiscipline(discipline.id)">
            {{ discipline.name }}
          </button>
        }
      </div>
    </div>

    <div class="filter-group">
      <h4>{{ 'COMPANY_PROFILE.MATERIALS_QUESTION' | translate }}</h4>
      <div class="filter-buttons">
        @for (material of materials; track material.id) {
          <button
            class="filter-btn"
            [class.active]="isMaterialSelected(material.id)"
            (click)="toggleMaterial(material.id)">
            {{ material.name }}
          </button>
        }
      </div>
    </div>
  </div>
</section>
